module.exports = __webpack_public_path__ + "img/straight-rail-diagonal-left-bottom-ties.3c9adea4.png";